import { render, staticRenderFns } from "./passAccount.vue?vue&type=template&id=7808fc65&scoped=true"
import script from "./passAccount.vue?vue&type=script&lang=js"
export * from "./passAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7808fc65",
  null
  
)

export default component.exports